<template>
  <form @submit.prevent="onSubmit" class="reviews__form">
    <div class="reviews__form-item reviews__form-rating"
         :class="{'reviews__form-item_warn': v$.formAddReview.assessment.$error}">
      <label for="assessment">Поставьте вашу оценку:</label>
      <div id="assessment" class="reviews__form-assessment-wrap">
        <div class="reviews__form-assessment">
          <input type="radio" :id="this._.uid + '.' + 1" value="1" v-model="formAddReview.assessment" name="assessment">
          <label :for="this._.uid + '.' + 1"
                 :class="[{ 'rating-active-star-icon': checkAssessment(1) }, 'rating-star-icon']"></label>
        </div>
        <div v-for="n in 4" class="reviews__form-assessment">
          <input type="radio" :id="this._.uid + '.' + (n + 1)" :value="n + 1" v-model="formAddReview.assessment"
                 name="assessment">
          <label :for="this._.uid + '.' + (n + 1)"
                 :class="[{ 'rating-active-star-icon': checkAssessment(n + 1) }, 'rating-star-icon']"></label>
        </div>
      </div>
      <div v-for="item in v$.formAddReview.assessment.$errors" class="reviews__form-warning"
           :class="{'reviews__form-warning_active': item}">
        {{ item.$message }}
      </div>
    </div>
    <div class="reviews__form-item">
      <label for="review"></label>
      <textarea id="review"
                v-model="formAddReview.review"
                class="reviews__form-input"
                :class="{'reviews__form-input_warn': v$.formAddReview.review.$error}"
                placeholder="Текст отзыва">
                        </textarea>
      <div v-for="item in v$.formAddReview.review.$errors" class="reviews__form-warning"
           :class="[{'reviews__form-warning_active': item}, 'reviews__form-warning_active-response']">
        {{ item.$message }}
      </div>
    </div>
    <AddedFile :review="review" @addFiles="addFiles" @deleteFile="deleteFile"
               :stateParentComponent="formShow"></AddedFile>
    <div class="reviews__form-item">
      <label for="advantage"></label>
      <textarea type="text"
                id="advantage"
                v-model="formAddReview.advantage"
                class="reviews__form-input reviews__form-input--height"
                placeholder="Опишите достоинства товара">
                        </textarea>
    </div>
    <div class="reviews__form-item">
      <label for="disadvantages"></label>
      <textarea type="text"
                id="disadvantages"
                v-model="formAddReview.disadvantages"
                class="reviews__form-input reviews__form-input--height"
                placeholder="Опишите недостатки товара">
                        </textarea>
    </div>
    <div class="reviews__form-item">
      <label for="comment"></label>
      <textarea type="text"
                id="comment"
                v-model="formAddReview.comment"
                class="reviews__form-input reviews__form-input--height"
                placeholder="Дополнительный комментарий">
                        </textarea>
    </div>
    <div class="reviews__form-item" :class="{'reviews__form-item_open-form': review}">
      <p class="reviews__form-info">Вы задаете вопрос как: <span>{{
          printUserName()
        }}</span></p>
      <div class="reviews__form-item reviews__form-switch">
        <span class="reviews__form-switch-title">Отставить отзыв анонимно</span>
        <label class="switch">
          <input type="checkbox" v-model="formAddReview.anonymous">
          <span class="slider round"></span>
        </label>
      </div>
      <p v-show="!review" class="reviews__form-message">Отзыв будет виден всем после проверки модератором</p>
    </div>
    <div class="button-form button-form__wrapper">
      <button :disabled="isOnSubmit" class="button-form__review-button button-red">{{ textButtonForm }}</button>
      <button type="button" class="button-form__review-button button-red" @click="closeForm()">
        {{ textButtonFormEdit }}
      </button>
    </div>

  </form>
</template>

<script>
import AddedFile from "@/components/AddedFile/AddedFile";
import {useVuelidate} from '@vuelidate/core';
import {required, helpers} from '@vuelidate/validators';

export default {
  name      : "FormReviews",
  components: {AddedFile},
  data() {
    return {
      v$           : useVuelidate(),
      isOnSubmit   : false,
      formAddReview: {
        assessment   : null,
        review       : '',
        advantage    : '',
        disadvantages: '',
        comment      : '',
        anonymous    : false,
        files        : [],
        delete_files : []
      },
    }
  },
  props      : {
    review      : {
      type   : Object,
      require: false
    },
    formShow    : Boolean,
    statusLoaded: Boolean
  },
  validations: {
    formAddReview: {
      review    : {
        required: helpers.withMessage("Заполните поле отзыва", required),
      },
      assessment: {
        required: helpers.withMessage("Оставте вашу оценку", required),
      }
    }
  },
  methods    : {
    onSubmit() {
      this.v$.$validate();
      if (!this.v$.$error) {
        this.isOnSubmit = true;
        this.$emit('onSubmit', this.formAddReview);
      }
    },
    closeForm() {
      this.$emit('closeForm');
    },
    printUserName() {
      this.$emit('printUserName')
    },
    checkAssessment(n) {
      return this.formAddReview.assessment - n >= 0
    },
    addFiles(arrayFiles) {
      this.formAddReview.files = arrayFiles;
    },
    deleteFile(fileUuid) {
      if (!this.formAddReview.delete_files.includes(fileUuid)) {
        this.formAddReview.delete_files.push(fileUuid);
      }
    },
    entryDescription() {
      if (this.review) {
        this.formAddReview.assessment = this.review.assessment;
        this.formAddReview.review = this.review.review.content_origin;
        this.formAddReview.advantage = this.review.review.advantage_origin;
        this.formAddReview.disadvantages = this.review.review.disadvantages_origin;
        this.formAddReview.comment = this.review.review.comment_origin;
        this.formAddReview.files = this.review.files;
      }
      return
    },
  },
  computed   : {
    textButtonForm() {
      return this.review ? 'Сохранить изменения' : 'Опубликовать отзыв'
    },
    textButtonFormEdit() {
      return this.review ? 'Отменить изменения' : 'Закрыть'
    }
  },
  mounted() {
    this.entryDescription();
  }
}
</script>